import { Component, Inject, Optional, DOCUMENT } from '@angular/core';
import { PagesHeaderComponent } from '../../components/pages-header/pages-header.component';
import { BuyerFooterComponent } from '../../../../Shared/components/buyer-footer/buyer-footer.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BreadCrumbsComponent } from '../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LandingService } from '../../_services/landing.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { LocalDateTimePipe } from 'src/app/Shared/_pipes/local-date-time';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';


import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';
import { Meta, Title } from '@angular/platform-browser';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import { SeoService } from 'src/app/Shared/_services/seo/seo.service';

@Component({
    selector: 'app-single-blog',
        standalone: true,
imports: [
    BreadCrumbsComponent,
    LocalDateTimePipe,
    SkeletonLoaderComponent,
    RouterLink,
    TranslatePipe
],
    templateUrl: './single-blog.component.html',
    styleUrl: './single-blog.component.scss',
    providers: [LocalDateTimePipe]
})
export class SingleBlogComponent {
  breadcrumbItems: Breadcrumb[] = [
    { label: 'Home', url: '/', translationKey: 'buyer_header.home' },
    { label: 'Blogs', url: '/blogs', translationKey: 'buyer_footer.blogs' },
    { label: '', translationKey: '' }, // This will be updated with the blog title,
  ];
  blogSlug!: string;
  blogData: any = null;
  blogImage: string = '';
  currentLang: any;

  isLoading: boolean = false;
  metaDescription: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private homeService: LandingService,
    private toastService: ToastService,
    private translate: TranslateService,
    private meta: Meta
  ,
    public localeService: LocaleService
  ) {
    this.route.params.subscribe((res) => {
      this.blogSlug = res['slug'];
      this.getBlogData();
    });
  }
  ngOnInit() {
  }
  getBlogData() {
    this.isLoading = true;
    this.homeService.getBlogDetails(this.blogSlug).subscribe({
      next: (response: any) => {
        this.isLoading = false;

        this.blogData = response;

        this.breadcrumbItems[2].label = this.blogData?.title;
        this.breadcrumbItems[2].translationKey = '';
      },
      error: (error) => {
        this.isLoading = false;

        this.toastService.showError(
          error?.error?.Error?.[0] ?? 'An error occurred while fetching Blogs.'
        );
      },
    });
  }

  getBlogImage(imageId: number) {
    this.homeService.getBlogImage(imageId).subscribe({
      next: (response: any) => {
        this.blogImage = response?.media_details?.sizes?.large?.source_url;
      },
      error: (error) => {
        this.toastService.showError(
          error?.error?.Error?.[0] ??
            'An error occurred while fetching Blog Image.'
        );
      },
    });
  }

}
